import type { SearchScope } from "@/features/meetings/services/contacts.api"

/**
 * Each scope's wider neighbours, outward from it: sub-Organization widens to
 * Organization then Global, Organization widens to Global, and Global has
 * nowhere wider to go.
 */
const WIDER: Record<SearchScope, SearchScope[]> = {
  subId: ["scopeId", "global"],
  scopeId: ["global"],
  global: [],
}

/**
 * The scopes to search, in order, for the New Chat picker.
 *
 * Browsing (empty query) stays on the selected tab only: a wider scope has
 * everyone in that reach, so silently showing it just because the narrower
 * one is empty would mean "Organization" or "Global" with no query typed
 * shows the SAME sub-Organization list, not the tab's own contents.
 *
 * A real search goes wider: the server matches partial name/email at every
 * scope, so a typed query keeps looking outward until something matches
 * rather than leaving the reader to switch tabs by hand.
 */
export function searchChain(selected: SearchScope, query: string): SearchScope[] {
  if (!query.trim()) return [selected]
  return [selected, ...WIDER[selected]]
}
